import { render, staticRenderFns } from "./surveItem5.vue?vue&type=template&id=0c1d4844&scoped=true"
import script from "./surveItem5.vue?vue&type=script&lang=js"
export * from "./surveItem5.vue?vue&type=script&lang=js"
import style1 from "./surveItem5.vue?vue&type=style&index=1&id=0c1d4844&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d4844",
  null
  
)

export default component.exports